































































































































































































































































































































































































import {Component, Prop, Vue} from "vue-property-decorator";

import {CarInfoInputModel} from "@/model/car-info/car-info-input.model";
import {TireConstant} from "@/model/car-info/tire-constant";

import {CarInfoInputChecker} from "@/model/car-info/functions/car-info-input-checker"
import {CarInfoInputCascadeManager} from "@/model/car-info/functions/car-info-input-cascade-manager";

import {CommonConstant} from "@/common-constant";


@Component
export default class CarInfoInput extends Vue {
    @Prop() private model: CarInfoInputModel;
    @Prop() private registerMode: boolean;

    /** タイヤサイズプルダウンリスト*/
    TireConstant = TireConstant;
    
    /** 国産車メーカの表示状態 */
    showDomesticMaker: boolean = true;

    /** 輸入車メーカの表示状態 */
    showImportMaker: boolean = false;

    /*********************************************************************************
     * スタイルクラス判定
     *********************************************************************************/

    /** メーカーパネルをスタイルクラスを返す */
    makerPanelClass(name: string): string {
        return this.model.maker === name ? "selected" : "";
    }

    /** 頭文字のスタイルクラスを返す */
    initialPanelClass(name: string): string {
        const exist = this.model.carTypeMaster.carTypeInitialsLinkedMaker.find(initial => initial.name === name);
        if ((typeof exist) !== 'undefined') {
          return this.model.typeInitialLetter === name ? "selected" : "";
        } else {
          return "disable";
        }
    }

    /** 車種パネルのスタイルクラスを返す */
    carPanelClass(name: string): string {
        return this.model.type === name ? "selected" : "";
    }

    /** 前タイヤサイズパネルのスタイルクラスを返す */
    carFrontTireSizeClass(name: string): string {
        return this.model.frontTireSize === name ? "selected" : "";
    }

    /** 後タイヤサイズパネルのスタイルクラスを返す */
    carReaTireSizeClass(name: string): string {
        return this.model.reaTireSize === name ? "selected" : "";
    }
    
    /*********************************************************************************
     * イベント関数（表示制御）
     *********************************************************************************/

    /** 国産車メーカパネルの表示/非表示を切り替える */
    toggleDomesticMaker() {
        this.showDomesticMaker = !this.showDomesticMaker;
    }

    /** 輸入車メーカパネルの表示/非表示を切り替える */
    toggleImportMaker() {
        this.showImportMaker = !this.showImportMaker;
    }

    /** メーカパネルの表示を切り替えボタンのキャプション（もっと見る or 折りたたむ） */
    showDomesticMakerCaption(): string {
      return this.showDomesticMaker ? '－' : '＋';
    }

    /** メーカパネルの表示を切り替えボタンのキャプション（もっと見る or 折りたたむ） */
    showImportMakerCaption(): string {
        return this.showImportMaker ? '－' : '＋';
    }

    /** メーカのロゴを設定する。画像がない場合、空白のアイコンを設定する*/
    makerImage(logoUrl) {
      try {
        return require(`@/asserts${logoUrl}`);
      } catch (e) {
        return require(`@/asserts/makers/other.png`);
      }
    }

    /** ロゴアイコンの存在するかによってロゴのnameのclassを設定する */
    setLogoNameClass(logoUrl) {
      try {
        require(`@/asserts${logoUrl}`);
        return 'name';
      } catch (e) {
        return 'no-image-name';
      }
    }

    /** ロゴアイコンが存在するかによってiconのclassを設定する */
    setIconClass(logoUrl) {
      try {
        require(`@/asserts${logoUrl}`);
        return 'icon';
      } catch (e) {
        return 'no-image-icon';
      }
    }
    
    /*********************************************************************************
     * イベント関数（値の入力）
     *********************************************************************************/

    /** メーカーパネルを選択する */
    async selectMaker(id: string, name: string) {
        await CarInfoInputCascadeManager.selectMaker(this.model, name);
        this.model.initMaker = false;

        // その他を選択した場合
        // フラグを設定、車種頭文字・車種にその他を設定、タイヤサイズを初期化
        // ※ 年式、型式の初期化はCascadeManagerで実施される
        this.model.selectedOtherMaker = (id == "other_domestic_car" || id == "other_imported_car");
        if (this.model.selectedOtherMaker) {
          await this.selectCarTypeInitial(CommonConstant.CAR_TYPE_INITIAL_OTHER);
          this.model.type = CommonConstant.CAR_TYPE_OTHER;
          CarInfoInputCascadeManager.selectFrontTireSize(this.model, "");
          CarInfoInputCascadeManager.selectReaTireSize(this.model, "");
        }
    }

    /** 頭文字を選択する */
    async selectCarTypeInitial(name: string) {
        await CarInfoInputCascadeManager.selectCarTypeInitial(this.model, name);
    }

    /** 車種パネルを選択する */
    async selectCarType(name: string) {
        await CarInfoInputCascadeManager.selectCarType(this.model, name);
        this.model.initType = false;
    }

    /** 年式を選択した際のイベント */
    selectModelYear() {
        CarInfoInputCascadeManager.selectModelYear(this.model, this.model.modelYear);
    }

    /** グレード・型式を選択した際のイベント */
    selectGradeModel() {
        CarInfoInputCascadeManager.selectGradeModel(this.model, this.model.model);
    }

    /** 前タイヤサイズを選択する */
    selectFrontTireSize(name: string) {
        CarInfoInputCascadeManager.selectFrontTireSize(this.model, name);
        this.model.errorMessage.frontFreeInputErrorMsg = "";
        // 前後で異なるサイズのタイヤを利用しているフラグが立っていない場合、後タイヤ手動入力のエラーメッセージを空に設定する。
        if (!this.model.showBothTireFlag) {
          this.model.errorMessage.reaFreeInputErrorMsg = "";
        }
    }

    /** 後タイヤサイズを選択する */
    selectReaTireSize(name: string) {
        CarInfoInputCascadeManager.selectReaTireSize(this.model, name);
        this.model.errorMessage.reaFreeInputErrorMsg = "";
    }

    /** 前タイヤサイズの幅・扁平率・リム径・エクストラロード・ランフラットタイヤを選択した際のイベント */
    selectFrontPullDown() {
        // タイヤサイズを初期化する
        this.model.frontTireSize = "";
        
        // エラーチェックを行う
        CarInfoInputChecker.checkFrontTirePulldown(this.model);
    }

    /** 後タイヤサイズの幅・扁平率・リム径・エクストラロードを選択した際のイベント */
    selectReaPullDown() {
        // タイヤサイズを初期化する
        this.model.reaTireSize = "";
        
        // エラーチェックを行う
        CarInfoInputChecker.checkRearTirePulldown(this.model);
    }

    /** 運輸支局をチェックする */
    inputTransportBranchOffice() {
        return CarInfoInputChecker.checkTransportBranchOffice(this.model);
    }

    /** 分類番号をチェックする */
    inputClassNumber(): boolean {
        return CarInfoInputChecker.checkClassNumber(this.model);
    }

    /** ひらがなをチェックする */
    inputHiragana() {
        return CarInfoInputChecker.checkHiragana(this.model);
    }

    /** 一連指定番号をチェックする */
    inputSerialNumber(): boolean {
        return CarInfoInputChecker.checkSerialNumber(this.model);
    }

    /** 前後異なるタイヤチェックボックスのイベント */
    changeCarTireCheckbox(checkbox) {
        CarInfoInputCascadeManager.changeCarTireCheckbox(this.model, checkbox, this.registerMode);
    }
}
